export function simpleObject(data) {
  return JSON.parse(JSON.stringify(data));
}

export function hashCode(s) {
  return s.split('').reduce(function(a, b) {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
}



/** WEBPACK FOOTER **
 ** ./~/web-message-helper/lib/utils.js
 **/